export const ru = {
    'banners-count': {
        one: '{count} объявление',
        some: '{count} объявления',
        many: '{count} объявлений',
        none: '{count} объявлений'
    }
};
